module.exports = __webpack_public_path__ + "img/benefit-05-iot-6.a27f81c2.png";